import {ChangeDetectorRef, Component, forwardRef, OnInit} from "@angular/core";
import {AbstractVisbosControl} from "../../../core/visbos-core/ui/forms/abstract-visbos-control";
import {IUser, MessageType} from "../../../shared/redux-store/session/session.types";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {SessionActions} from "../../../shared/actions/session.actions";
import {appInjector} from "../../../index";
import {PasswordChangeComponent} from "../../../core/visbos-core/components/password-change/password-change.component";
import {FORM_ERROR_MESSAGES} from "../../../core/visbos-core/assets/form-error-messages";
import {UserService} from "../../user/user.service";
import {ErrorHandlerService} from "../../../core/visbos-core/error-handling/error-handler.service";

@Component({
  selector: 'vb-profile-form',
  templateUrl: './profile-form.component.html',
  styleUrls: ['./profile-form.component.css'],
  providers: [{provide: AbstractVisbosControl, useExisting: forwardRef(() => ProfileFormComponent)}]
})
export class ProfileFormComponent extends AbstractVisbosControl<IUser, FormGroup> implements OnInit {

  errorDefs = FORM_ERROR_MESSAGES;

  constructor(fb: FormBuilder, cd: ChangeDetectorRef, sessionActions: SessionActions, private errorHandler: ErrorHandlerService,
              private userService: UserService) {
    super(fb, cd, sessionActions);
  }

  ngOnInit() {
    super.ngOnInit();
  }

  buildControlContent(values?: IUser, ...params): FormGroup {
    return ProfileFormComponent.initControl(this.fb);
  }

  public static initControl(fb: FormBuilder = null): FormGroup {
    fb = fb ? fb : appInjector().get(FormBuilder);

    return fb.group({
      form_of_address: [null],
      academic_title: [null],
      pre_name: [null],
      name: [null, Validators.required],
      email: [null, Validators.email],
      password: PasswordChangeComponent.initControl(fb)
    });

  }

  public setDefaultValues(item?: IUser): { [controlKey: string]: any } | any {
    return {
      form_of_address: this.setValue(item, 'form_of_address'),
      academic_title: this.setValue(item, 'academic_title'),
      pre_name: this.setValue(item, 'pre_name'),
      name: this.setValue(item, 'name'),
      email: this.setValue(item, 'email'),
    };
  }

  updatePassword() {
    let pwForm = this.control.get('password').value;
    this.userService.updateUserPassword(pwForm.oldPassword, pwForm.password).subscribe(
      res => {
        this.sessionActions.pushMessage("Das Passwort wurde erfolgreich geändert!", MessageType.SUCCESS, "Passwortänderung");
        this.control.get('password').reset();
      },
      err => {
        this.errorHandler.handleUserError(err)
      }
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/crm/components/profile-form/profile-form.component.ts